import type { OrganizationPublic } from "@/client"
import { PercentileColorSchemeEditor } from "@/components/Organizations/PercentileColorSchemeEditor"
import type { PercentileColorScheme } from "@/types/percentileColors"
import { Box, Heading, Stack, Text } from "@chakra-ui/react"
import { BrandingDisplayName } from "./BrandingDisplayName"
import { BrandingLogoUpload } from "./BrandingLogoUpload"

interface OrganizationBrandingProps {
  organization: OrganizationPublic
}

export function OrganizationBranding({
  organization,
}: OrganizationBrandingProps) {
  const initialScheme =
    (organization.settings
      ?.percentile_color_scheme as PercentileColorScheme | null) ?? null

  return (
    <Box>
      <Box mb={6}>
        <Heading size="lg" mb={2}>
          Branding
        </Heading>
        <Text color="gray.600">
          Customize how your organization appears to students throughout the
          platform.
        </Text>
      </Box>

      <Stack gap={8}>
        <Box>
          <Heading size="md" mb={4}>
            Logo
          </Heading>
          <BrandingLogoUpload organization={organization} />
        </Box>

        <Box>
          <Heading size="md" mb={4}>
            Display Name
          </Heading>
          <BrandingDisplayName organization={organization} />
        </Box>

        <Box>
          <Heading size="md" mb={4}>
            Percentile Colors
          </Heading>
          <PercentileColorSchemeEditor
            orgId={organization.id}
            initialScheme={initialScheme}
          />
        </Box>
      </Stack>
    </Box>
  )
}
